import { CompleteFieldSelector } from '@/types/fields-api.model';

import { SPORT_FIELDS, RANKING_FIELDS } from '../sport/sport-fields.config';
import { CLUB_FIELDS } from '../clubs/clubs-fields.config';
import { PLAYER_FIELDS } from '../player/player-fields.config';

const TOURNAMENT_FIELDS_MINIMAL = {
  id: true,
  name: true,
  startDate: true,
  endDate: true,
};

const TOURNAMENT_FIELDS_BASIC = {
  ...TOURNAMENT_FIELDS_MINIMAL,
  description: true,
  bannerUrl: true,
  sport: SPORT_FIELDS.BASIC,
  price: {
    value: true,
    currency: {
      isoCode: true,
      name: true,
    },
  },
  signupDeadlineDate: true,
  type: true,
  gender: true,
  minCategory: {
    id: true,
    name: true,
    minimumElo: true,
    sport: SPORT_FIELDS.FULL,
  },
  maxCategory: {
    id: true,
    name: true,
    minimumElo: true,
    sport: SPORT_FIELDS.FULL,
  },
  minTeamsAllowed: true,
  maxTeamsAllowed: true,
  minAge: true,
  maxAge: true,
  status: true,
  inPause: true,
  getmatchFee: true,
  format: true,
  overflowGroupClassification: true,
  americanFinalBracketSize: true,
  americanGroupFormat: true,
};

const TOURNAMENT_FIELDS_DEFAULT = {
  ...TOURNAMENT_FIELDS_BASIC,
  prizes: true,
  paymentType: true,
  forceSum: true,
  countsForCategoryRanking: true,
  categoryRankingTarget: true,
  categoryRankingCategory: {
    id: true,
    name: true,
    minimumElo: true,
    sport: SPORT_FIELDS.FULL,
  },
  playersPerTeam: true,
  matchDuration: true,
  minSchedulesRequired: true,
  teamsPerGroups: true,
  classifiedPerGroups: true,
  fixtureType: true,
  hasFixture: true,
  hasActiveFixture: true,
  isKnockoutOnly: true,
  minTeamsToGenerate: true,
  knockoutUsesEveryDay: true,
  knockoutStartDate: true,
  knockoutStartTime: true,
  teams: {
    id: true,
    players: {
      id: true,
      name: true,
      username: true,
      gender: true,
      rankings: RANKING_FIELDS.BASIC,
    },
  },
  clubs: CLUB_FIELDS.BASIC,
};

const TOURNAMENT_FIELDS_FULL: CompleteFieldSelector<unknown> = {
  ...TOURNAMENT_FIELDS_DEFAULT,
  sport: SPORT_FIELDS.FULL,
  price: {
    id: true,
    value: true,
    currency: {
      isoCode: true,
      name: true,
    },
  },
  teams: {
    id: true,
    players: PLAYER_FIELDS.FULL,
  },
  isBelowMinimumTeams: true,
  registrations: {
    id: true,
    status: true,
    paymentType: true,
    paymentMethod: true,
    payedBy: true,
    managerPayedBy: true,
    createdAt: true,
    availability: {
      date: true,
      dayOfWeek: true,
      timeRange: {
        qty: true,
        courtsQuantity: true,
        startTime: true,
        endTime: true,
      },
    },
    team: {
      id: true,
      players: PLAYER_FIELDS.FULL,
    },
  },
  schedule: {
    club: CLUB_FIELDS.FULL,
    schedule: {
      date: true,
      dayOfWeek: true,
      timeRange: {
        qty: true,
        courtsQuantity: true,
        startTime: true,
        endTime: true,
      },
    },
    id: true,
    name: true,
    description: true,
    knockoutStartDate: true,
    knockoutStartTime: true,
  },
  timezone: true,
  endsAt: true,
  clubs: CLUB_FIELDS.FULL,
};

const TOURNAMENT_FIELDS_LIST = {
  ...TOURNAMENT_FIELDS_BASIC,
  clubs: {
    id: true,
    name: true,
    address: {
      city: true,
      state: true,
    },
  },
  timezone: true,
  bannerUrl: true,
  endsAt: true,
  registrations: {
    id: true,
    status: true,
    team: {
      id: true,
      players: {
        id: true,
        name: true,
      },
    },
  },
};

export const TOURNAMENT_FIELDS = {
  MINIMAL: TOURNAMENT_FIELDS_MINIMAL,
  BASIC: TOURNAMENT_FIELDS_BASIC,
  DEFAULT: TOURNAMENT_FIELDS_DEFAULT,
  FULL: TOURNAMENT_FIELDS_FULL,
  LIST: TOURNAMENT_FIELDS_LIST,
} as const;
